// Constantes de base : taille des tuiles, niveaux, cases traversables.
// Extrait de KubeWorld.jsx au lot A (2026-09-08) : le code n'a pas ete modifie.

// Tuiles de 16 px affichees en 32 : agrandissement exact x2, donc pixels nets.
const T=32,VW=22,VH=15,CW=VW*T,CH=VH*T;
const LVS=[{l:1,x:0,t:'Stagiaire'},{l:2,x:50,t:'Junior SRE'},{l:3,x:130,t:'SRE'},{l:4,x:250,t:'Senior SRE'},{l:5,x:400,t:'Lead SRE'},{l:6,x:600,t:'Staff SRE'},{l:7,x:850,t:'Principal'},{l:8,x:1150,t:'Architect'},{l:9,x:1500,t:'Master'},{l:10,x:2000,t:'God'}];
const getLv=xp=>{let r=LVS[0];for(const l of LVS)if(xp>=l.x)r=l;return r;};
const getNxt=xp=>LVS.find(l=>xp<l.x);

// Walkable chars
const WK=new Set('.,=+B*FSLDo rgpbcJCKQGmena'.split(''));
const isWalk=(ch)=>WK.has(ch);

const pickRandom=(arr)=>arr[Math.floor(Math.random()*arr.length)];

export { T, VW, VH, CW, CH, LVS, getLv, getNxt, WK, isWalk, pickRandom };
